<template>
    <span v-if="setupStateText !== ''" class="badge" :class="setupCssClass">{{
        $t('support.setupState.' + setupStateText)
    }}</span>
</template>
<script>
export default {
    data: function() {
        return {};
    },
    props: ['setupStatus'],
    computed: {
        setupCssClass() {
            const setupStatus = this.setupStatus;

            if (setupStatus === -10) {
                return { duplicate: true };
            } else if (setupStatus === 0) {
                return { pending: true };
            } else if (setupStatus < 0) {
                return { error: true };
            } else if (setupStatus < 60) {
                return { inProgress: true };
            } else if (setupStatus === 60) {
                return { done: true };
            } else if (setupStatus === 110) {
                return { duplicate: true };
            } else if (setupStatus === 120) {
                return { done: true };
            }

            return {};
        },
        setupStateText() {
            const setupStatus = this.setupStatus;

            if (setupStatus === -10) {
                return 'possibleduplicate';
            } else if (setupStatus === 0) {
                return 'pending';
            } else if (setupStatus < 0) {
                return 'error';
            } else if (setupStatus < 60) {
                return 'inprogress';
            } else if (setupStatus === 60) {
                return 'done';
            } else if (setupStatus === 110) {
                return 'duplicate';
            } else if (setupStatus === 120) {
                return 'manuelDone';
            }
            return '';
        }
    }
};
</script>
